// extracted by mini-css-extract-plugin
export var input = "ToggleButton-module--input--CDxDq";
export var label = "ToggleButton-module--label--lQAE3";